/**
 * The version-history / edit-log grid for the admin screens.
 *
 * Same columns as `EditLogTable` (both come from `buildEditLogColumnDefs`), but
 * rendered through `AdminGrid` so a log reads as one of the section's tables:
 * bordered and rounded, small-caps headers, sized to its rows, and the hover
 * expander once it runs past the cap.
 *
 * Promoted out of the pricing screen when Guidelines needed the same treatment.
 */
import PropTypes from "prop-types";
import { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";

import { buildEditLogColumnDefs, editLogRowId } from "./EditLogTable";
import { ADMIN_GRID_COL_DEF, AdminGrid } from "./adminGrid";
import { AdminEmpty } from "./AdminScreenShell";

export default function AdminEditLog({
  rows,
  onRevert,
  // Adds a "Sheet as of" column (rows carry `asOfDate`) — DSCR versions.
  asOfColumn,
  maxRows = 10,
  flush,
  empty = "No entries logged.",
}) {
  const columnDefs = useMemo(
    () => buildEditLogColumnDefs(onRevert, { asOf: asOfColumn }),
    [onRevert, asOfColumn],
  );

  if (!rows?.length) return <AdminEmpty>{empty}</AdminEmpty>;

  return (
    <AdminGrid rowCount={rows.length} maxRows={maxRows} flush={flush}>
      <AgGridReact
        rowData={rows}
        columnDefs={columnDefs}
        defaultColDef={ADMIN_GRID_COL_DEF}
        getRowId={editLogRowId}
      />
    </AdminGrid>
  );
}

AdminEditLog.propTypes = {
  rows: PropTypes.array,
  onRevert: PropTypes.func,
  asOfColumn: PropTypes.bool,
  maxRows: PropTypes.number,
  flush: PropTypes.bool,
  empty: PropTypes.node,
};
